const routes = {
    main: "/",
    home: "/home",

    // Auth
    auth: "/auth",
    verifyEmail: "/verify-email",
    forgotPassword: "/forgot-password",
    changePassword: "/change-password",

    // Main
    profile: "/profile",
    // Client
    serviceSearch: "/services",
    providerDetail: "/provider/:id",
    serviceDetail: "/service/:id",
    requests: "/requests",
    requestCreate: "/request/create",
    requestDetail: "/request/:id",
    requestConfirm: "/request/confirm/:id",
    quoteDetail: "/quote/:id",
    paymentUpload: "/payment/upload",
    paymentUploadWithId: "/payment/upload/:requestId",
    paymentDetail: "/payment/:id",
    reviewDetail: "/review/:id",
    complaintCreate: "/complaint/create",
    chat: "/chat/:id",
    conversations: "/chats",
    // Provider
    providerServices: "/provider/services",
    providerRequests: "/provider/requests",
    providerWallet: "/provider/wallet",
    providerSetup: "/provider/setup",
    providerSelectServices: "/provider/select-services",
    providerAddOffering: "/provider/add-offering",
    providerAddCertification: "/provider/add-certification",
    providerConfigureProfile: "/provider/configure-profile",
    providerVerificationStatus: "/provider/verification-status",
    providerOfferingDetail: "/provider/offering/:id",
    providerQuoteDetail: "/provider/quote/:id",
    providerWithdrawal: "/provider/withdrawal",
    
    notFound: "*",
};

export default routes;